require('angular-bootstrap-npm');
require('angular-resource');
require('angular-cookies');
require('ng-file-upload');
require('lodash');
require('angular-moment');
require('ng-idle');
require('leaflet');
require('./third_party/leaflet-marker/l.lbMarker.js');
require('leaflet.markercluster');
require('leaflet.gridlayer.googlemutant/Leaflet.GoogleMutant');

const app = angular.module('app', [
  'ngRoute', 'ngResource', 'ngSanitize', 'ngCookies', 'ui.select', 'ui.bootstrap', 'ngFileUpload', 'angularMoment',
  'ngIdle',
  require('./components/lbaRouteRoot/lbaRouteRoot').name,
  require('./components/lbaGrid').name,
  require('./components/lbaGridItem').name,
  require('./components/lbaDynamic').name,
  require('./components/lbaResource').name,
  require('./components/lbaSubHeading').name,
  require('./components/lbaTabs').name,
  require('./components/lbaGroup').name,
  require('./components/lbaTextInput').name,
  require('./components/lbaUrl').name,
  require('./components/lbaNav').name,
  require('./components/lbaLoader').name,
  require('./components/lbaAddGridResource').name,
  require('./components/lbaBoolean').name,
  require('./components/lbaSwitch').name,
  require('./components/lbaCountrySelect').name,
  require('./components/lbaTagInput').name,
  require('./components/lbaFileUploader').name,
  require('./components/lbaFileDownloader').name,
  require('./components/lbaSelect').name,
  require('./components/lbaODataIndexMultiSelect').name,
  require('./components/lbaMultiSelect').name,
  require('./components/lbaMultiSelectGroup').name,
  require('./components/lbaKeyValuePair').name,
  require('./components/lbaRange').name,
  require('./components/lbaBreadCrumb').name,
  require('./components/lbaHotel').name,
  require('./components/lbaHotelReview').name,
  require('./components/lbaEditHotel/lbaEditHotel').name,
  require('./components/lbaPointsOfInterest').name,
  require('./components/lbaRedirect/lbaRedirect').name,
  require('./components/lbaSearchBy').name,
  require('./components/lbaTextArea').name,
  require('./components/lbaODataSelect').name,
  require('./components/lbaTimeZoneSelect').name,
  require('./components/lbMap').name,
  require('./components/lbaSubNav/lbaSubNav').name,
  require('./components/lbaLatLongMapSearch').name,
  require('./components/lbaLatLngMap').name,
  require('./components/lbaHotelTagSelect').name,
  require('./components/lbaPolicyCodeSelect').name,
  require('./components/lbaFeatureSelect').name,
  require('./components/lbaDebtorMultiSelect').name,
  require('./components/lbaReasonForTravelSelect').name,
  require('./components/lbaCompanyReferenceCodeSelect').name,
  require('./components/lbaTagSelect').name,
  require('./components/lbaSpacer').name,
  require('./components/lbaConfirmButton').name,
  require('./components/lbaRemarksEditor').name,
]);

app.config(require('./config/routerConfig')(app));
app.config(require('./config/authConfig')(app));

app.service('dataSourceService', require('./services/dataSourceService'));
app.constant('AUTH_EVENTS', require('./constants/authConstants'));
app.factory('authInterceptor', require('./factories/authInterceptor'));
app.service('authService', require('./services/authService'));
app.service('settingsService', require('./services/settingsService'));
app.service('dataService', require('./services/dataService'));
app.service('indexService', require('./services/indexService'));
app.service('subNavService', require('./services/subNavService'));
app.service('microApiService', require('./services/microApiService'));
app.directive('clickOutside', require('./components/lbaClickOutside'));

app.config(['$compileProvider', '$locationProvider', function($compileProvider, $locationProvider) {
  $compileProvider.preAssignBindingsEnabled(true);
  $locationProvider.hashPrefix('');
}]);

app.run(['$injector', $injector => {
  app.register = $injector.loadModule.bind($injector);
}]);

app.run(['$templateCache', $templateCache => {
  $templateCache.put('gridPaginationTpl.html', require('./templates/gridPaginationTpl.html'));
}]);

app.run(['$rootScope', '$location', 'authService', 'dataService', ($rootScope, $location, authService, dataService) =>
  $rootScope.$on('$routeChangeStart', function (event, next, current) {
    if (current && current.$$route && current.$$route.originalPath === "/hotel-rankings") {
      window.location.reload();
    }

    if (dataService.cleanDataOnRouteChange) {
      dataService.data = angular.copy(dataService.addNewBackup);
      dataService.cleanDataOnRouteChange = false;
      dataService.addNewMode = false;
    }

    if (!authService.isAuthenticated()) {
      if (next.$$route.originalPath !== '/login') {
        authService.prevRoute = $location.path();
        event.preventDefault();
        $location.path('/login');
      }
    }
  })
]);

app.run(['$rootScope', '$location', 'AUTH_EVENTS', 'authService', ($rootScope, $location, AUTH_EVENTS, authService) =>
  $rootScope.$on(AUTH_EVENTS.loginSuccess, function () {
    if (authService.prevRoute) {
      $location.path(authService.prevRoute);
    } else {
      $location.path('/');
    }
  })
]);

app.run(['$rootScope', '$location', 'AUTH_EVENTS', ($rootScope, $location, AUTH_EVENTS) =>
  $rootScope.$on(AUTH_EVENTS.logoutSuccess, function () {
    $location.path('/login');
  })
]);

app.run(['$rootScope', '$location', 'AUTH_EVENTS', ($rootScope, $location, AUTH_EVENTS) =>
  $rootScope.$on(AUTH_EVENTS.notAuthenticated, function () {
    $location.path('/login');
  })
]);

app.run(['Idle', function (Idle) {
  Idle.watch();
}]);

app.config(['KeepaliveProvider', 'IdleProvider', function (KeepaliveProvider, IdleProvider) {
  IdleProvider.idle(19 * 60);
  IdleProvider.timeout(1);
}])
  .run(['$rootScope', 'authService', 'AUTH_EVENTS', ($rootScope, authService, AUTH_EVENTS) => {
    $rootScope.$on('IdleTimeout', function () {
      authService.logout().then(function () {
        $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
      });
    });
  }]);

export default app;



// WEBPACK FOOTER //
// ./src/app.js